<div class="question">
  <p [class]="{'required' : question.isRequired}">{{question.title}}</p>
  <app-attachments
    [downloadOnly]="true" 
    [attachments]="question.attachments"
    [downloadRoute]="downloadRoute">
  </app-attachments>
  <div class="file-field md-form">
    <button type="button" mdbBtn class="btn-outline" [class.btn-invalid]="invalidFile" [class.valid]="fileName && !invalidFile"
            (click)="fileInput.click()" mdbWavesEffect>
      <span *ngIf="!fileName && !invalidFile">Upload</span>
      <span *ngIf="fileName && !invalidFile"><i class="fa fa-check-circle"></i> {{fileName}}</span>
      <span *ngIf="invalidFile"><i class="fa fa-close"></i>Unsupported File Type or Size</span>
    </button>
    <input [hidden]="true" #fileInput type="file" [accept]="acceptableFileTypesText" (change)="fileSelected($event)" />
    <a href="javascript:void(0);" *ngIf="fileName || invalidFile" (click)="removeFile()">Remove</a>
  </div>
  <div>
    <span>Acceptable: {{acceptableFileTypesText}} file types (5 MB max)</span>
  </div>
</div>
